// ======================================================================
// File Name       : SelectUserGroupDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Modal, Form, Col, Button } from 'react-bootstrap';
import { MESSAGE_TYPE, MESSAGE_TIME_OUT, MODAL_SIZE } from '../../constants/index';
import GroupTree from './GroupTree';
import { MSG_GROUP_EXIST } from '../../constants/MessageTemplate';
import MessageView from '../MessageView';

class SelectGroupDlg extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTargetGroup: {},
      message: {
        messageVisible: false,
        messageType: MESSAGE_TYPE.error,
        messageHeader: '',
        messageContent: [],
      },
    };
    this.checkGroupExist = this.checkGroupExist.bind(this);
    this.showMessage = this.showMessage.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.handleSelectNode = this.handleSelectNode.bind(this);
  }

  showMessage(msg, msgType) {
    const message = {
      messageVisible: true,
      messageType: msgType,
      messageHeader: '',
      messageContent: [msg],
    };
    this.setState({
      message,
    });
  }

  dismissMessage() {
    const message = {
      messageVisible: false,
      messageType: MESSAGE_TYPE.error,
      messageHeader: '',
      messageContent: [],
    };
    this.setState({
      message,
    });
  }

  componentWillMount() {
    this.setState({
      selectedTargetGroup: null,
    });
  }

  checkGroupExist(selectedTargetGroup, groupSecernId) {
    let isExist = false;
    if (this.props.selectedGroupList && this.props.selectedGroupList.length
      && selectedTargetGroup && groupSecernId !== selectedTargetGroup.groupSecernId) {
      for (const selectedGroup of this.props.selectedGroupList) {
        if (selectedGroup.groupSecernId === selectedTargetGroup.groupSecernId) {
          isExist = true;
          break;
        }
      }
    }
    return isExist;
  }
  /**
   * Handle event when click on OK of select group dialog
   *
   */
  onOK() {
    let isExist = false;
    isExist = this.props.selectedGroup && this.checkGroupExist(this.state.selectedTargetGroup, this.props.selectedGroup.groupSecernId);
    if (!isExist) {
      this.props.onOK(this.state.selectedTargetGroup);
    } else {
      this.showMessage(MSG_GROUP_EXIST, MESSAGE_TYPE.error);
    }
  }

  /**
   * Handle select node
   *
   * @param {*} event
   * @param {object} node
   */
  handleSelectNode(event, node) {
    if (!node) return;
    if (this.props.selectedGroup && this.checkGroupExist(node.data, this.props.selectedGroup.groupSecernId)) {
      this.showMessage(MSG_GROUP_EXIST, MESSAGE_TYPE.error);
    } else {
      this.dismissMessage();
    }
    this.setState({
      selectedTargetGroup: node.data,
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    const shouldNotUpdate =
    nextState.message.messageVisible === this.state.message.messageVisible &&
    nextState.message.messageType === this.state.message.messageType &&
    nextProps.groupList === this.props.groupList &&
    nextProps.showModal === this.props.showModal &&
    nextProps.selectedGroupList === this.props.selectedGroupList &&
    nextProps.selectedGroup === this.props.selectedGroup;
    return !shouldNotUpdate;
  }

  /**
   * Render GUI
   * @returns {XML}
   */
  render() {
    const style = {
      background: 'none',
      width: '100%',
      marginLeft: 0,
      left: 0,
    };
    return (
      <Modal
        className="modal-container"
        show={this.props.showModal}
        size={MODAL_SIZE.lg}
        style={style}
      >
        <Modal.Header onHide={this.props.onCancel} closeButton>
          <Modal.Title className="text-center">
            ユーザーグループを選択してください
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="padding-10">
          <MessageView
            message={this.state.message}
            onDismiss={this.dismissMessage}
          />
          <Col sm={12}>
            <Form className='form-horizontal'>
              <GroupTree
                groupList={this.props.groupList}
                selectedGroup={this.props.selectedGroup}
                handleSelectNode={this.handleSelectNode}
              />
            </Form>
          </Col>
        </Modal.Body>
        <Modal.Footer className="text-center">
          <Button variant="default" className="btn-96 margin-10" onClick={this.props.onCancel}>
            キャンセル
          </Button>
          <Button variant="primary" className="btn-96 margin-10" onClick={this.onOK.bind(this)}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default SelectGroupDlg;
